import styles from './Form.module.css';
import React from "react";
import { Zoom, Fade} from "react-awesome-reveal";
import imgLogo from "./logo.png";
function Form(props) {

  return (
      <div ref={props.childRef} >

          <div style={{position: 'fixed', width: '100%', zIndex: 999999999}}>
              <a href="tel://061113743283">
                  <div className={styles.phone}>+49 611 13743283</div>
              </a>


          </div>


          <div>
              <div style={{position: 'absolute', zIndex: -99, width: '100%', overflowX: "hidden"} } >

                  <center>
                      <video
                          loop muted autoPlay controls = ''
                          style={{filter: 'brightness(50%)', maxWidth: '1200px'}}
                          preload="auto"
                          width="100%"
                          id="video"
                          src="/video.mp4" type="video/mp4"

                          ref={props.videoRef}>
                      </video>

                  </center>
              </div>
          </div>


          <div className="wrapperSlim">

              <center>
                  <Fade triggerOnce delay="120">
                      <img className={styles.test} style={{width: 'calc(var(--fp1) * 300)', opacity: 0.4}} src={imgLogo} />
                  </Fade>
              </center>

              <center>
                  <Fade triggerOnce delay="140">
                      <div className={styles.test} style={{color: '#FFFFFF', opacity: 0.4, fontSize: 'calc(var(--fp1) * 64)'}}>HDE</div>
                  </Fade>
              </center>
              <div className="grid">
                  <div className="col-4">
                      <Zoom triggerOnce direction="left">
                          <div className={styles.button}>
                              <div style={{fontWeight: 'bold'}}>Kostenlose</div>
                              Nachbesserung
                          </div>
                      </Zoom>
                  </div>
                  <div className="col-4">
                      <Zoom triggerOnce delay="20">
                          <div className={styles.button}>
                              <div style={{fontWeight: 'bold'}}>24 Stunden</div>
                              persönlicher Kontakt
                          </div>
                      </Zoom>
                  </div>
                  <div className="col-4">
                      <Zoom triggerOnce direction="right">
                          <div className={styles.button}>
                              <div style={{fontWeight: 'bold'}}>Monatlich</div>
                              kündbar
                          </div>
                      </Zoom>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Form;
